/** Phone numbers and the texting registration (spec 16 §4.3). */

export interface LocationNumber {
  e164: string;
  display: string;
  role: 'main' | 'text' | 'outbound_caller_id' | 'fax';
  /** Whether ELVA does anything with it at all. */
  usedByElva: boolean;
  /** What ELVA does with it, as prose — the only part of a phone number this
   * product has an opinion about. */
  what: string;
  source: 'account_app';
}

export const NUMBER_ROLE_LABEL: Record<LocationNumber['role'], string> = {
  main: 'Main line',
  text: 'Text line',
  outbound_caller_id: 'Outbound caller ID',
  fax: 'Fax',
};

/**
 * A2P 10DLC. US carriers require every business number to be registered before
 * it may send texts, and while this is pending or rejected **carriers reject
 * every message** — not bounce, reject (P277).
 */
export interface TextingRegistration {
  status: 'approved' | 'pending' | 'rejected' | 'not_started';
  approvedAt?: string;
  reason?: string;
}

export const REGISTRATION_WORD: Record<TextingRegistration['status'], string> = {
  approved: 'Approved',
  pending: 'Pending',
  rejected: 'Rejected',
  not_started: 'Not started',
};

export interface PhoneData {
  numbers: LocationNumber[];
  texting: TextingRegistration;
  syncedMinutesAgo: number;
}
